import React, { useEffect } from "react";
import { useDataLayer } from "../../../../Contexts/DataLayer.context.jsx";
import BigBoxButtons from "./bigBoxButtons.component.jsx";
import { useMask } from "../../../../Contexts/mask.context.jsx";

const BigBox = ({
  title,
  children,

  // header buttons
  onAddFunction = null,
  onAddText = "+",
  addNote, // send '-' to hide
  closeButton = false,
  onCloseButton = null,

  showThirdButton = false,
  thirdButtonText = "Action",
  thirdButtonClick = null,

  showFourthButton = false,
  fourthButtonText = "Action 2",
  fourthButtonClick = null,

  showResetPosition = false,
  onReset = null,

  // style
  zIndex = 2050,
  backgroundColor = "alert-secondary",

  // mask
  mask = false,
  maskReason = "Unsaved changes. Please save first.",

  // list buttons
  showListDropdown = false,
}) => {
  const { listArray, sharedListArray, savedQueryArray } = useDataLayer();

  const bgRaw = (backgroundColor || "").trim();
  const useBootstrapClass =
    bgRaw === "" ||
    bgRaw.includes("alert-") ||
    bgRaw.includes("bg-") ||
    bgRaw.includes("text-");

  const headerClass =
    bgRaw === ""
      ? "alert-secondary"
      : useBootstrapClass
        ? bgRaw
        : "alert-secondary";

  const headerStyle = useBootstrapClass ? {} : { backgroundColor: bgRaw };

  const handleClose = (e) => {
    e.stopPropagation();
    if (typeof onCloseButton === "function") onCloseButton();
  };

  const handleThirdButton = (e) => {
    e.stopPropagation();
    if (typeof thirdButtonClick === "function") thirdButtonClick();
  };

  const handleFourthButton = (e) => {
    e.stopPropagation();
    if (typeof fourthButtonClick === "function") fourthButtonClick();
  };

  const handleReset = (e) => {
    e.stopPropagation();
    if (typeof onReset === "function") onReset();
  };

  const { mask: baseMask, unmask: baseUnmask } = useMask() || {};

  useEffect(() => {
    if (typeof baseMask === "function") baseMask();
    return () => {
      if (typeof baseUnmask === "function") baseUnmask();
    };
  }, [baseMask, baseUnmask]);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        zIndex,
        border: "4px solid var(--bs-success)",
        borderRadius: 0,
        boxSizing: "border-box",
        backgroundColor: "var(--bs-body-bg)",
        boxShadow: "0 6px 22px rgba(0,0,0,0.22)",
        overflow: "hidden",
      }}
      className="card shadow-sm bb-box"
    >
      <div className="card-header d-flex align-items-center p-0">
        <div
          className={`d-flex align-items-center col-48 p-2 w-100 m-0 ${headerClass}`}
          style={{ ...headerStyle, position: "relative" }}
        >
          {showListDropdown === true && (
            <BigBoxButtons
              lists={listArray}
              shareLists={sharedListArray}
              sharedQueries={savedQueryArray}
              disabled={mask === true}
              disabledReason={maskReason}
            />
          )}

          {showResetPosition === true && (
            <button
              type="button"
              className="btn btn-sm btn-outline-primary ms-2"
              style={{ height: 30, padding: "0 10px" }}
              onClick={handleReset}
              disabled={mask === true}
              title={maskReason}
            >
              Reset
            </button>
          )}

          <div className="text-primary fw-bold flex-grow-1 text-center fs-5">
            {title}
          </div>

          <div className="d-flex align-items-center">
            {showThirdButton === true && (
              <button
                type="button"
                className="btn btn-sm btn-outline-warning"
                style={{ marginRight: "5px", height: 30, padding: "0 10px" }}
                onClick={handleThirdButton}
                disabled={mask === true}
                title={maskReason}
              >
                {thirdButtonText}
              </button>
            )}

            {showFourthButton === true && (
              <button
                type="button"
                className="btn btn-sm btn-outline-warning"
                style={{ marginRight: "45px", height: 30, padding: "0 10px" }}
                onClick={handleFourthButton}
                disabled={mask === true}
                title={maskReason}
              >
                {fourthButtonText}
              </button>
            )}

            {addNote !== "-" && (
              <button
                className="btn btn-sm btn-outline-success"
                style={{ marginRight: "5px", height: 30, padding: "0 8px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (typeof onAddFunction === "function") onAddFunction();
                }}
                disabled={mask === true}
                title={maskReason}
              >
                {onAddText}
              </button>
            )}

            {closeButton === true && (
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                style={{ height: 30, padding: "0 10px" }}
                onClick={handleClose}
                disabled={mask === true}
                title={maskReason}
              >
                Close
              </button>
            )}
          </div>

          {mask === true && (
            <div
              aria-hidden="true"
              title={maskReason}
              style={{
                position: "absolute",
                inset: 0,
                background: "rgba(255,255,255,0.60)",
                cursor: "not-allowed",
                zIndex: 9999,
                pointerEvents: "auto",
              }}
            />
          )}
        </div>
      </div>

      <div
        className="card-body p-2"
        style={{
          height: "calc(100% - 52px)",
          overflow: "hidden",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default BigBox;
